import { render, staticRenderFns } from "./sendConfirmDialog.vue?vue&type=template&id=3855b558&scoped=true"
import script from "./sendConfirmDialog.vue?vue&type=script&lang=js"
export * from "./sendConfirmDialog.vue?vue&type=script&lang=js"
import style0 from "./sendConfirmDialog.vue?vue&type=style&index=0&id=3855b558&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3855b558",
  null
  
)

export default component.exports